import React from 'react';
import { Menu } from 'semantic-ui-react';

import UserPanel from './UserPanel';
import Favourites from './Favourites';
import Channels from './Channels';
import DirectMessages from '../Chat Section/DirectMessages';

class SidePanel extends React.Component {

  // Sidepanel Dashboard
  render() {
    const { currentUser } = this.props;
    return(
      <Menu size='large' inverted fixed='left' vertical style={{ background: '#191919', fontSize: '1.2rem' }}>
        <UserPanel currentUser = {currentUser} />
        <Favourites currentUser = {currentUser} />
        <Channels currentUser = {currentUser} />
        <DirectMessages currentUser={currentUser} />
      </Menu>
    );
  }

}

export default SidePanel;